module.exports = __webpack_public_path__ + "static/media/intelligence.849e2c00.svg";